import React from 'react';
import { Box, Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';

type Props = {
  tooltip: string;
};

const useStyles = makeStyles(theme =>
  createStyles({
    infoContainer: {
      maxHeight: 24,
      maxWidth: 24,
      flexShrink: 0,
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(3)
      }
    },
    infoIcon: {
      color: 'var(--light-outline)',
      fontSize: '1.4rem',
      cursor: 'pointer'
    }
  })
);

const StyledTooltip = withStyles(theme => ({
  popper: {
    marginTop: theme.spacing(-1)
  },
  tooltip: {
    backgroundColor: 'var(--black-transparent)',
    color: 'var(--white)',
    maxWidth: '230px',
    fontSize: '0.75rem',
    'font-weight': '400',
    lineHeight: '1rem',
    letterSpacing: '0.025em',
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1.5)}px`
  }
}))(Tooltip);

export const InfoTooltip: React.FC<Props> = ({ tooltip }) => {
  const classes = useStyles();

  return (
    <StyledTooltip placement="right-start" title={<div>{tooltip}</div>} enterTouchDelay={0} leaveTouchDelay={3000}>
      <Box className={classes.infoContainer}>
        <InfoOutlinedIcon className={classes.infoIcon} />
      </Box>
    </StyledTooltip>
  );
};
